import { deepQuerySelector } from "./theme.js";

/**
 * custom.js
 * Place your custom web components below.
 */

var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) =>
  member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (
  __accessCheck(obj, member, "read from private field"),
  getter ? getter.call(obj) : member.get(obj)
);
var __privateAdd = (obj, member, value) =>
  member.has(obj)
    ? __typeError("Cannot add the same private member more than once")
    : member instanceof WeakSet
    ? member.add(obj)
    : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (
  __accessCheck(obj, member, "write to private field"),
  setter ? setter.call(obj, value) : member.set(obj, value),
  value
);
var __privateMethod = (obj, member, method) => (
  __accessCheck(obj, member, "access private method"), method
);

var PackSelector = class extends HTMLElement {
  connectedCallback() {
    this.tplPrice = this.dataset.tplPrice || '{price}';
    this.tplDiscount = this.dataset.tplDiscount || '';
    this.currencySymbol = this.dataset.currencySymbol || 'R';
    this.initialBasePrice = parseInt(this.dataset.initialPrice) || 0;
    this.tabs = this.querySelectorAll('.pack-tab');

    this.formQuantityInput = document.getElementById(`${this.dataset.productFormId}-quantity`);

    this.addEventListener('quantity-pack-change', this.onPackChange.bind(this));

    const defaultChecked = this.querySelector('input[name="quantity-selection"]:checked');
    if (defaultChecked && this.formQuantityInput) {
      this.formQuantityInput.value = defaultChecked.value;
    }

    this.boundOnVariantChange = this.onVariantChange.bind(this);
    this.closest('body').addEventListener('variant:change', this.boundOnVariantChange);

    this.updateAllPrices(this.initialBasePrice);
  }

  disconnectedCallback() {
    this.closest('body').removeEventListener('variant:change', this.boundOnVariantChange);
  }

  onPackChange(event) {
    if (this.formQuantityInput) {
      this.formQuantityInput.value = event.detail.quantity;
    }
  }

  onVariantChange(event) {
    const variant = event.detail.variant;
    const newPrice = (variant && variant.price) ? variant.price : 0;
    this.updateAllPrices(newPrice);
  }

  updateAllPrices(base_cents) {
    if (isNaN(base_cents)) { base_cents = 0; }

    this.tabs.forEach(label => {
      const subheadingEl = label.querySelector('.tab-subheading');
      const inputId = label.getAttribute('for');
      const inputEl = this.querySelector(`#${inputId}`);

      if (!subheadingEl || !inputEl) return;

      const packSize = parseInt(inputEl.value) || 1;
      const discountPct = parseInt(inputEl.dataset.discount) || 0;

      const m = 100 - discountPct;
      const p_raw = (base_cents * m) / 100;
      const p_up_single = Math.ceil(p_raw);
      const s_raw = (base_cents - p_up_single) * packSize;
      const s_down = Math.floor(s_raw);
      
      const price_rounded = (discountPct === 0) ? p_up_single : (Math.ceil(p_up_single / 100) * 100);
      const saving_rounded = (discountPct === 0) ? s_down : (Math.floor(s_down / 100) * 100);
      
      const priceStr = this.formatMoney(price_rounded);
      const savingStr = this.formatMoney(saving_rounded);

      let priceSub = '';
      let discountSub = '';
      if (discountPct === 0) {
        priceSub = this.tplPrice.replace('{price}', priceStr).replace('{discount}', savingStr);
        if (this.dataset.tplPrice === '{price}') {
          priceSub = priceStr;
        }
      } else {
        priceSub = this.tplPrice.replace('{price}', priceStr).replace('{discount}', savingStr);
        discountSub = this.tplDiscount.replace('{price}', priceStr).replace('{discount}', savingStr);
      }
      
      if (discountSub) {
        subheadingEl.innerHTML = `${priceSub}<br>${discountSub}`;
      } else {
        subheadingEl.innerHTML = priceSub;
      }
    });
  }

  formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) {
      cents = 0;
    }
    let value = (cents / 100).toFixed(2);
    if (value.endsWith('.00')) {
      value = (cents / 100).toFixed(0);
    }
    return `${this.currencySymbol}${value}`;
  }
};
var PackSelectorInput = class extends HTMLInputElement {
  constructor() {
    super();
    this.addEventListener("click", this._onValueChanged);
  }

  _onValueChanged(event) {
    const checkedRadio = event.target;
    const parentComponent = this.closest('pack-selector');
    if (!parentComponent) return;

    const allLabels = parentComponent.querySelectorAll('.pack-tab');
    allLabels.forEach(label => {
        label.classList.remove('active');
    });

    const labelForCheckedRadio = parentComponent.querySelector(`label[for="${checkedRadio.id}"]`);
    if (labelForCheckedRadio) {
        labelForCheckedRadio.classList.add('active');
    }

    const newQuantity = checkedRadio.value;
    const discount = checkedRadio.dataset.discount;
    this.dispatchEvent(new CustomEvent('quantity-pack-change', {
      bubbles: true,
      composed: true,
      detail: { quantity: newQuantity, discount: discount }
    }));
  }
};
if (!window.customElements.get("pack-selector")) {
  window.customElements.define("pack-selector", PackSelector);
}
if (!window.customElements.get("pack-selector-input")) {
  window.customElements.define("pack-selector-input", PackSelectorInput, { extends: "input"}); 
}